export type Suggestion = {
  id: string;
  label: string;
};

export type ForwardGeocodeResult = {
  lat: number;
  lng: number;
  name: string;
  formatted?: string;
};

export async function fetchForwardGeocode(
  text: string,
): Promise<ForwardGeocodeResult | null> {
  try {
    const res = await fetch(
      `/api/geocode/forward?text=${encodeURIComponent(text)}`,
    );
    if (!res.ok) return null;
    const body = (await res.json()) as { result: ForwardGeocodeResult | null };
    return body.result ?? null;
  } catch {
    return null;
  }
}

export async function fetchAutocompleteSuggestions(
  text: string,
): Promise<Suggestion[]> {
  const res = await fetch(
    `/api/geocode/autocomplete?text=${encodeURIComponent(text)}`,
  );
  if (!res.ok) return [];
  const body = (await res.json()) as { suggestions: Suggestion[] };
  return body.suggestions ?? [];
}
